const UiTooltipFunctionPropsOption = {
  classExtraName: { type: String },
  trigger: { type: String },
  //? 窗口隐藏是触发模式
  content: { type: String },
  //? 窗口内容, 可被slot#content替换
  offsetX: { type: Number, default: 20 },
  offsetY: { type: Number, default: 20 },
  zIndex: { type: Number, default: 66 },
  width: { type: Number }
  //? 最大宽度
};
const UiTooltipFunctionEmits = {
  "before-enter": () => true,
  "before-leave": () => true,
  "after-enter": () => true,
  "after-leave": () => true
};

export { UiTooltipFunctionEmits, UiTooltipFunctionPropsOption };
//# sourceMappingURL=index.mjs.map
